import type { FC } from "react";

import type { IAppFeatureGiftCard } from "./AppFeatureGiftCard";
import { AppFeatureGiftCard } from "./AppFeatureGiftCard";
import type { IAppFeatureItem } from "./AppFeatureItem";
import { AppFeatureItem } from "./AppFeatureItem";

export interface IAppFeatureSection {
    trackerUrl: string;
    initialData: IAppFeatureSectionResult;
}

export interface IAppFeatureSectionResult {
    appFeatureList: IAppFeatureItem[];
    appFeatureGiftCard: IAppFeatureGiftCard;
}

const AppFeatureSection: FC<IAppFeatureSection> = ({ initialData }) => {
    return (
        <>
            {initialData?.appFeatureList?.length
                ? initialData.appFeatureList.map((item, i) => <AppFeatureItem key={i} {...item} />)
                : null}

            <AppFeatureGiftCard
                {...initialData.appFeatureGiftCard}
                isLeftOrientated={initialData.appFeatureList.length % 2 === 0}
            />
        </>
    );
};

export default AppFeatureSection;
